import styled from 'styled-components';

export const StyledForm = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;

  width: 300px;
  height: 350px;

  form {
    .heading {
      text-align: center;
      text-transform: uppercase;
    }
  }
`;

export const Container = styled.div`
  background-color: #eee;
  width: 100vw;
  height: 100vh;
  position: relative;
`;
